<template>
    <div class="container">
        <navigation />

        <div class="row">
            <div class="col-12 text-left">
                <a @click="$router.go(-1)" class="btn btn-link btn-back-link">&laquo; Back</a>
                <router-link to="/deals" class="btn btn-primary btn-bellstores btn-subnav">
                    All Deals
                </router-link>
                <router-link to="/deals/in-progress" class="btn btn-primary btn-bellstores btn-subnav">
                    In Progress
                </router-link>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <h1>Deals In Progress</h1>
            </div>
        </div>

        <div class="row" v-if="errorMessages.length > 0">
            <div class="col-12">
                <div v-for="error in errorMessages" v-bind:key="error">
                    <div class="alert alert-danger">
                        {{error}}
                    </div>
                </div>
            </div>
        </div>

        <div class="row" v-if="dealsFetched && offers.length > 0">
            <div class="col-12">
                <div class="row offer-grid">
                    <div class="col-xs-12 col-sm-12 col-md-6 col-lg-4 offer" v-for="(offer, index) in offers" :key="index">
                        <div class="row">
                            <div class="col-12">
                                <div class="offer-img-wrapper">
                                    <router-link :to="`/deals/detail/${offer.offerId}`">
                                        <img class="img img-fluid" :src="getOfferImage(offer)" />
                                    </router-link>
                                </div>
                                <div class="offer-text">
                                    <p v-if="offer.offerStartDate || offer.offerEndDate" class="expires">
                                        {{ formatDateRange(offer) }}
                                    </p>
                                    <div class="reward-text">
                                        <p class="reward-amount" v-if="offer.offerDescription">
                                            <router-link :to="`/deals/detail/${offer.offerId}`">
                                                {{ offer.offerDescription }}
                                            </router-link>
                                        </p>
                                        <p class="reward-value" v-if="offer.rewardAmount && offer.rewardType" v-html="formatReward(offer)"></p>
                                    </div>
                                    <p class="view-deal">
                                        <router-link :to="`/deals/detail/${offer.offerId}`">
                                            View Details
                                        </router-link>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="deal-progress row">
                            <div class="deal-progress-indicator col-xs-12 col-sm-6">
                                <div v-if="offer.unitType === 'USD'">
                                    <div class="progress-bar">
                                        <div class="progress-bar-inner" v-bind:style="calculateOfferProgressBarWidth(offer)"></div>
                                    </div>
                                </div>
                                <div v-else>
                                    <span v-for="(indicator, index) in getIndicatorsArray(offer)" :key="index">
                                        <font-awesome-icon :icon="solidCircle" v-if="indicator === 1"></font-awesome-icon>
                                        <font-awesome-icon :icon="regularCircle" v-else></font-awesome-icon>
                                    </span>
                                </div>
                            </div>
                            <div class="deal-progress-remaining col-xs-12 col-sm-6">
                                {{ getProgressRemaining(offer) }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" v-else-if="dealsFetched">
            <div class="col-12">
                Sorry, there are no deals available at this time.
            </div>
        </div>
        <div class="row" v-else>
            <div class="col-12">
                <div class="spinner-wrapper">
                    <font-awesome-icon :icon="spinnerIcon" class="spinner"></font-awesome-icon>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import APIResponseError from '@/models/responses/APIResponseError'
import APIRequestError from '@/models/responses/APIRequestError'
import moment from 'moment'
import { faSpinner, faCircle as solidCircle } from '@fortawesome/free-solid-svg-icons'
import { faCircle as regularCircle } from '@fortawesome/free-regular-svg-icons'

export default {
    name: 'OffersInProgress',
    dependencies: ['apiService', 'storageService'],
    data () {
        return {
            offers: [],
            errorMessages: [],
            dealsFetched: false
        }
    },
    async mounted () {
        await this.getOffers()
    },
    methods: {
        formatReward (offer) {
            // Shows reward type: PERCNT_OFF = X%, AMT_OFF = $X, CPG = X¢/gal
            let reward = ''
            switch (offer.rewardType) {
            case 'PERCNT_OFF':
                if (parseFloat(offer.rewardAmount) === 100) {
                    reward = 'FREE'
                } else {
                    reward = offer.rewardAmount + '% OFF'
                }
                break
            case 'AMT_OFF':
                reward = '$' + offer.rewardAmount + ' OFF'
                break
            case 'CPG':
                reward = (offer.rewardAmount * 100) + '&cent;/gal'
                break
            default:
                reward = offer.rewardAmount + '&cent;/gal'
            }

            return reward
        },
        formatDate (dateStr) {
            return moment(dateStr).format('l')
        },
        formatDateRange (offer) {
            if (offer.offerStartDate) {
                return 'Valid: ' + this.formatDate(offer.offerStartDate)
            } else if (offer.offerEndDate) {
                return 'Expires: ' + this.formatDate(offer.offerEndDate)
            } else {
                return 'Valid: ' + this.formatDate(offer.offerStartDate) + ' - ' + this.formatDate(offer.offerEndDate)
            }
        },
        async getOffers () {
            const response = await this.apiService.rewardsInProgress()
            if (response instanceof APIRequestError || response instanceof APIResponseError) {
                this.errorMessages.push(response.message())
                this.dealsFetched = true
                return
            }

            this.offers = response.offers()
            this.dealsFetched = true
            console.log(this.offers)
        },
        getOfferImage (offer) {
            const image = 'https://ed0c37be21f8ad72418b-ae99f0738c1a4f0c153c7aecac9360e1.ssl.cf1.rackcdn.com/elevate/app/' + offer.imageName + '@3x.png'

            return image
        },
        getProgressRemaining (offer) {
            let remaining = parseFloat(parseFloat(offer.offerRequirement) - parseFloat(offer.curPurchaseBal))

            switch (offer.unitType) {
            case 'USD':
                remaining = '$' + remaining.toFixed(2) + ' to go'
                break
            default:
                remaining = remaining.toFixed(0) + ' to go'
            }

            return remaining
        },
        getIndicatorsArray (offer) {
            const indicators = []
            const currentProgress = parseFloat(offer.curPurchaseBal).toFixed(0)
            const offerRequirement = parseFloat(offer.offerRequirement).toFixed(0)
            let i

            for (i = 0; i < offerRequirement; i++) {
                if (i < currentProgress) {
                    indicators.push(1)
                } else {
                    indicators.push(0)
                }
            }

            console.log(indicators)

            return indicators
        },
        calculateOfferProgressBarWidth (offer) {
            const currentProgress = parseFloat(offer.curPurchaseBal)
            const offerRequirement = parseFloat(offer.offerRequirement)

            return 'width:' + parseFloat((currentProgress / offerRequirement) * 100).toFixed(2) + '%'
        }
    },
    computed: {
        solidCircle () {
            return solidCircle
        },
        regularCircle () {
            return regularCircle
        },
        spinnerIcon () {
            return faSpinner
        }
    }
}
</script>

<style scoped lang="scss">
    .spinner-wrapper {
        margin-top: 20px;

        .fa-spinner {
            width: 50px;
            height: 50px;
        }
    }

    @media screen and (min-width: 768px) {
        .reward-text {
            min-height: 88px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/OffersInProgress.vue